var _style, _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymenticon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000158000350411116351440000011815990950738234271_);}\r\n\t.st1{fill:#2E4D9C;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 3.1,
    width: 24,
    height: 17.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062871240830129922760000014349799861408319132_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000062871240830129922760000014349799861408319132_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.7,12.5H1.3c0,0.1,0,0.2,0,0.3c0,2,0,4,0,6c0,0.6,0.2,0.8,0.9,0.9h15.2c0.5,0,0.8,0.2,0.8,0.6 c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0H2.2 c-1.4,0-2.2-0.8-2.2-2.2c0-4.5,0-8.9,0-13.4c0-1.3,0.8-2.2,2.2-2.2h19.6c1.4,0,2.2,0.8,2.2,2.2v13.4c0,1.4-0.8,2.2-2.2,2.2 c-0.6,0-1.3,0-1.9,0c-0.5,0-0.8-0.3-0.8-0.7c0-0.4,0.3-0.7,0.8-0.7c0.7,0,1.4,0,2.1,0c0.5,0,0.7-0.3,0.7-0.7c0-2.1,0-4.2,0-6.2 C22.7,12.6,22.7,12.5,22.7,12.5z M22.7,8.5H3.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3-0.1-0.4-0.2C2.3,8.1,2.2,7.9,2.2,7.8 c0-0.2,0.1-0.3,0.2-0.4s0.3-0.2,0.4-0.2c0.1,0,0.2,0,0.3,0h19.5c0-0.6,0-1.2,0-1.9c0-0.6-0.2-0.8-0.8-0.8H2.2 c-0.6,0-0.8,0.2-0.8,0.8c0,1.8,0,3.7,0,5.5v0.3h21.3V8.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymenticon1);
export default __webpack_public_path__ + "static/media/Paymenticon1.2ec97dea83c0556de072765a568f4cca.svg";
export { ForwardRef as ReactComponent };